module.exports = __webpack_public_path__ + "toBride1-we-b-n.49a24244.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride1-we-b-n.jpg
// module id = xSVu
// module chunks = 0